import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.3go+2/',
    defaultMessage: 'Action reference',
  },
  description: {
    id: 'studio.wVyEN/',
    defaultMessage: 'Reference documentation for Appsemble action definitions',
  },
  showYaml: {
    id: 'studio.4yUiUe',
    defaultMessage: 'Show YAML',
  },
});
